import { h } from "preact";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Popconfirm } from "antd";
import { getPropertiesStatus } from "../../../functions";
import { TagCompoent } from "../../../components/tag/styled";
import { Center } from "../../../style/styled";
import { Text } from "../../../components/text";
import { IColumnData } from "../interfaces/table";

export const COULMN_DATA = (props?: any): IColumnData[] => [
  {
    title: "ลำดับ",
    dataIndex: "index",
    key: "index",
    width: "4em",
  },
  {
    title: "รหัสคำขอ",
    dataIndex: "requestNo",
    key: "requestNo",
    width: "8em",
  },
  {
    title: "หมายเลขการจอง",
    dataIndex: "reserveId",
    key: "reserveId",
    width: "10em",
    render: (text) => {
      return <Text size={"XS"} text={text as string} bold={true} />;
    },
  },
  {
    title: "รหัส SO",
    dataIndex: "saleOrder",
    key: "saleOrder",
    width: "10em",
  },
  {
    title: "รหัส Invoice",
    dataIndex: "invoiceId",
    key: "invoiceId",
    width: "10em",
  },
  {
    title: "เลข Lot",
    dataIndex: "saleLotId",
    key: "saleLotId",
    width: "10em",
  },
  {
    title: "รหัสเซลล์",
    dataIndex: "saleCode",
    key: "saleCode",
    width: "8em",
  },
  {
    title: "รหัสลูกค้า",
    dataIndex: "customerCode",
    key: "customerCode",
    width: "10em",
  },
  {
    title: "Search Name",
    dataIndex: "searchName",
    key: "searchName",
    width: "16em",
    align: "left",
  },
  {
    title: "เงื่อนไข",
    dataIndex: "reserveType",
    key: "reserveType",
    width: "5em",
    render: (text) => {
      return <Text size={"XS"} text={text as string} bold={true} />;
    },
  },
  {
    title: "เงื่อนไขการแลก",
    dataIndex: "exchangeCondition",
    key: "exchangeCondition",
    width: "16em",
    align: "left",
  },
  {
    title: "จำนวน",
    dataIndex: "quantity",
    key: "quantity",
    width: "6em",
    render: (text) => {
      return <Text size={"XS"} text={text as string} bold={true} />;
    },
  },
  {
    title: "วันที่จอง",
    dataIndex: "createDate",
    key: "createDate",
    width: "12em",
  },
  {
    title: "รายการออเดอร์",
    dataIndex: "detail",
    key: "detail",
    width: "20em",
  },
  {
    title: "หมายเหตุ",
    dataIndex: "remark",
    key: "remark",
    width: "20em",
  },
  {
    title: "สถานที่จัดส่ง",
    dataIndex: "addressName",
    key: "addressName",
    width: "30em",
    align: "left",
  },
  {
    title: "version เครื่องตัด",
    dataIndex: "versionMachine",
    key: "versionMachine",
    width: "10em",
  },
  {
    title: "สถานะ",
    dataIndex: "reserveStatusId",
    key: "reserveStatusId",
    fixed: "right",
    width: "10em",
    render: (text, _record) => {
      const { color, text: t } = getPropertiesStatus(`${text}`);
      return (
        <Center>
          <TagCompoent color={color}>{t}</TagCompoent>
        </Center>
      );
    },
  },
  {
    title: "",
    key: "button",
    width: "10em",
    fixed: "right",
    render: (_record: any) => {
      return (
        <div>
          <Popconfirm
            placement="bottomRight"
            title={"คุณต้องการลบรายการ"}
            onConfirm={() => props.onDelete(_record)}
            okText="ใช่"
            cancelText="ไม่ใช่"
          >
            {
              (
                <Button
                  type="primary"
                  shape="circle"
                  icon={(<DeleteOutlined />) as React.ReactNode}
                  style={{ marginRight: 10 }}
                  disabled={_record.reserveStatusId === "STRH-100"}
                  danger
                />
              ) as React.ReactNode
            }
          </Popconfirm>
          <Button
            type="primary"
            shape="circle"
            onClick={() => props.onEdit(_record)}
            icon={(<EditOutlined />) as React.ReactNode}
          />
        </div>
      );
    },
  },
];
